import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export const filterTypeMap = {
  status: { name: "status", type: "dropdown" },
  date: { name: "date", type: "dateRange" },
  orin: {
    name: "origin",
    type: "dropdown",
    default_value: undefined
  },
  dest: {
    name: "destination",
    type: "dropdown",
    default_value: undefined
  },
  ordering: {
    name: "ordering",
    type: "twoOption",
    default_value: "-created_at"
  }
};

export const filterData = [
  {
    type: "dropdown",
    label: i18n.t("order.state"),
    firstOptionLabel: i18n.t("all.states"),
    options: [
      {
        label: i18n.t("orders.status.DRA"),
        selected: "false",
        id: "DRA",
        type: "status"
      },
      {
        label: i18n.t("orders.status.PEN"),
        selected: "false",
        id: "PEN",
        type: "status"
      },
      {
        label: i18n.t("orders.status.PRO"),
        selected: "false",
        id: "PRO",
        type: "status"
      },
      {
        label: i18n.t("orders.status.DISP"),
        selected: "false",
        id: "DISP",
        type: "status"
      },
      {
        label: i18n.t("orders.status.REJ"),
        selected: "false",
        id: "REJ",
        type: "status"
      },
      {
        label: i18n.t("orders.status.COM"),
        selected: "false",
        id: "COM",
        type: "status"
      }
    ],
    name: "status"
  },
  {
    type: "dropdown",
    options: [],
    label: capitalize(i18n.t("order.origin")),
    firstOptionLabel: i18n.t("all.origin"),
    name: "orin"
  },
  {
    type: "dropdown",
    options: [],
    label: capitalize(i18n.t("order.destination")),
    firstOptionLabel: i18n.t("all.destinations"),
    name: "dest"
  },
  {
    type: "dateRange",
    label: i18n.t("date.range"),
    name: "date",
    enabled: true,
  }
];
